import createApp, { type ClientApplication } from "@shopify/app-bridge";

let appBridgeInstance: ClientApplication | null = null;

export function getShopifyHost(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("host");
}

export function isEmbeddedShopifyApp(): boolean {
  return !!getShopifyHost();
}

export function getShopifyAppBridge(): ClientApplication | null {
  const host = getShopifyHost();
  const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;

  if (!host || !apiKey) {
    return null;
  }

  if (!appBridgeInstance) {
    appBridgeInstance = createApp({
      apiKey,
      host,
      forceRedirect: true,
    });
  }

  return appBridgeInstance;
}